<template>
<div class="container-fluid">
    <div class="form-head d-flex mb-3 align-items-start">
        <div class="mr-auto d-none d-lg-block">
            <!-- <p class="mb-0">Here is your general customers list data</p> -->
        </div>

        <b-button variant="outline-info" to="purchase-request">
            <b-icon icon="arrow-left" aria-hidden="true" class="mr-2" animation="fade"></b-icon> Back to Purchase Request List
        </b-button>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-header">
                    <div>
                        <h4 class="card-title">Create Purchase Request</h4>
                    </div>
                    <!-- <div class="card-action card-tabs mt-3 mt-sm-0">

                    </div> -->
                </div>
                <div class="card-body">
                    <form ref="formAdd" @submit.prevent="" class="mt-5">
                        <div class="form-row">

                            <div class="form-group col-md-4 col-lg-3">
                                <label class="text text-info">No. Purchase Request</label>
                                <input type="text" class="form-control" placeholder="Enter the number purchase request" readonly required v-model="formInput.no_pr" />
                                <label class="text-danger error">{{ validation.firstError('formInput.no_pr') }}</label>
                            </div>

                        </div>
                    </form>
                    <hr class="pb-2">
                    <form ref="formAdd" @submit.prevent="handleOk">
                        <div class="form-row">
                            <div class="form-group col-md-8 col-lg-9">
                                <label class="text text-info">Select Product</label>
                                <v-select label="name" :filterable="false" :options="products" v-model="selected" @search="onSearchProduct" @input="setSelectedProduct">
                                    <template slot="no-options"> type to search product... </template>
                                    <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            <dl>
                                                <dt class="text text-sm text-muted">{{option.principle_name}}</dt>
                                                <dd>[{{option.part_number}}] {{option.name}}</dd>
                                            </dl>
                                            <!-- [{{ option.principle_name}}] [{{ option.part_number}}] {{ option.name }} -->
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                            {{ option.name }}
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                            <div class="form-group col-md-4 col-lg-3">
                                <label class="text text-info">Qty</label>
                                <!-- <input type="number" class="form-control" v-model="product.qty" placeholder="Enter the quantity" min="1"> -->
                                <div class="input-group">
                                    <input type="number" class="form-control" v-model.number="product.qty" placeholder="Enter the quantity" min="1">
                                    <div class="input-group-append">
                                        <b-button variant="outline-info" type="submit">
                                            <b-icon icon="plus-circle" aria-hidden="true" class="mr-2" animation="fade"></b-icon> Add Product
                                        </b-button>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <!-- <button type="button" @click="addPIC" class="btn btn-outline-info btn-sm">
                <i class="fa fa-plus mr-2"></i> Add PIC
            </button> -->
                    </form>
                    <!-- <div class="form-head d-flex mb-3 align-items-start">
                        <div class="mr-auto d-none d-lg-block"></div>
                        <b-button variant="outline-info" v-b-modal.modal-add>
                            <b-icon icon="plus-circle" aria-hidden="true" class="mr-2" animation="fade"></b-icon> Add Product
                        </b-button>
                    </div> -->
                    <div class="pt-4 table-responsive" v-if="listProduct.length > 0">
                        <table class="table primary-table-bordered text-center">
                            <thead class="thead-primary">
                                <tr>
                                    <th>Principle</th>
                                    <th>Name</th>
                                    <th>Qty</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(val, index) in listProduct" :key="index">
                                    <td>{{ val.principle_name }}</td>
                                    <td>{{ val.name }}</td>
                                    <td>{{ val.qty }}</td>
                                    <td>
                                        <div class="text-center">
                                            <!-- <a href="#" class="btn btn-primary shadow btn-xs sharp mr-1"><i class="fa fa-pencil"></i></a> -->
                                            <button class="btn btn-danger shadow btn-xs sharp" type="button" @click="deleteProduct(index)"><i class="fa fa-trash"></i></button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="card-footer border-0 pt-0" v-if="listProduct.length > 0">
                    <!-- <p class="card-text d-inline">Card footer</p> -->
                    <button type="button" class="btn btn-outline-success mb-1 mr-1 float-right" @click="handleSubmit"><i class="fa fa-save  mr-1"></i> Save Purchase Request</button>
                </div>
            </div>
        </div>
    </div>
    <!-- <b-modal id="modal-add" ref="my-modal-add" title="Product to list" size="xl" centered no-close-on-esc no-close-on-backdrop @ok="handleOk">

    </b-modal> -->
</div>
</template>

<script>
import axios from 'axios';
import {
    Validator
} from 'simple-vue-validator';
import "bootstrap-vue/dist/bootstrap-vue.css";
const moment = require("moment");

export default {
    name: 'CreatePurchaseRequest',
    metaInfo: {
        title: 'Solusi Dental',
        titleTemplate: 'Create Purchase Request | %s',
    },
    data() {
        return {
            // customers: [],
            products: [],
            product: {
                name: '',
                qty: 1,
                id_product: ''
            },
            selected: [],
            listProduct: [],
            formInput: {
                // id_customer: '',
                // id_sales_order: '',
                no_pr: '',
                products: []
            }
        }
    },
    validators: {
        'formInput.no_pr': function (value) {
            return Validator.value(value).required('No Purchase Request is required');
        },
    },
    async created() {
        await this.requestNumberPR();
        await this.onSearchProduct('a');
    },
    methods: {
        async requestNumberPR() {
            try {
                const params = new URLSearchParams();
                params.append('type', 'PR');
                params.append('back_date', 0);
                // params.append('date', new Date());
                params.append('date', moment().format('YYYY-MM-DD'));

                await this.$store.dispatch('setLoading', true);
                const resp = await axios.get(
                    "dental-erp-service/generate/number", {
                        params: params,
                        headers: {
                            Authorization: localStorage.getItem("token") || "",
                        },
                    }
                );

                if (resp.data.error === false) {
                    return this.formInput.no_pr = resp.data.data.number;
                }

            } catch (error) {
                if (error.response != undefined) {
                    if (error.response.data != undefined) {
                        if (error.response.data.error_auth != undefined) {
                            this.$swal.fire("Request Number PR", error.response.data.message, "error");
                            this.$store.dispatch("logOut").then(() => {
                                this.$router.push("/login");
                            });
                            return;
                        }
                        return this.$swal.fire("Request Number PR", error.response.data.message, "error");
                    }
                }

                this.$sentry.captureException(error);
                this.$swal.fire("Error", error.message, "error");
            } finally {
                this.$store.dispatch('setLoading', false);
            }
        },

        async onSearchProduct(query) {
            try {
                if (query.length == 0) {
                    return false;
                }

                const resp = await axios.post(
                    "dental-erp-service/product_list/wh", {
                        limit: 25,
                        page: 1,
                        search: query,
                        column: "",
                        ascending: false,
                    }, {
                        headers: {
                            Authorization: localStorage.getItem("token") || "",
                        },
                    }
                );

                if (resp.data.error === false) {
                    this.products = resp.data.data;
                }
            } catch (error) {

                if (error.response != undefined) {
                    if (error.response.data != undefined) {
                        if (error.response.data.error_auth != undefined) {
                            this.$swal.fire("Request Products", error.response.data.message, "error");
                            this.$store.dispatch("logOut").then(() => {
                                this.$router.push("/login");
                            });
                            return;
                        }
                        return this.$swal.fire("Request Products ", error.response.data.message, "error");
                    }
                }

                this.$sentry.captureException(error);
                this.$swal.fire("Error", error.message, "error");
            }
        },
        setSelectedProduct(product) {
            if (product == null) {
                this.product = {
                    id_product: '',
                    name: '',
                    qty: this.product.qty
                };
                return;
            }
            this.product = {
                id_product: product.id,
                name: product.name,
                principle_name: product.principle_name,
                qty: this.product.qty
            }
        },
        async deleteProduct(index) {
            this.listProduct.splice(index, 1);
            // await this.listProduct.splice(this.listProduct.indexOf(event), 1);
        },
        async handleOk() {
            if (this.product.id_product == "") {
                return false;
            }

            let index = this.listProduct.findIndex((obj => obj.id_product == this.product.id_product));
            this.selected = [];
            // console.log(index);
            if (index >= 0) {
                // console.log('simpan');
                this.listProduct[index].qty = parseInt(this.listProduct[index].qty) + parseInt(this.product.qty);
                return;
            }

            await this.listProduct.push(this.product);
            this.product = {
                name: '',
                qty: 1,
                id_product: ''
            };
        },
        async handleSubmit() {

            this.$validate().then(async (success) => {
                if (!success) {
                    return false;
                }

                this.formInput.products = [];
                await this.listProduct.forEach(element => {
                    for (let index = 0; index < parseInt(element.qty); index++) {
                        this.formInput.products.push({
                            id_product: element.id_product
                        })
                    }
                });

                try {
                    await this.$store.dispatch("setLoading", true);
                    let resp = await axios.post(
                        'dental-erp-service/purchase_request/wh/store',
                        this.formInput, {
                            headers: {
                                Authorization: localStorage.getItem("token") || "",
                            },
                        }
                    );

                    if (resp.data.error === false) {
                        this.$swal.fire("Success", resp.data.message, "success");
                        this.formInput = {
                            no_pr: '',
                            products: []
                        };
                        this.listProduct = [];
                        this.$router.push('purchase-request');
                    }
                } catch (error) {
                    if (error.response != undefined) {
                        if (error.response.data != undefined) {
                            if (error.response.data.error_auth != undefined) {
                                this.$swal.fire("Error", error.response.data.message, "error");
                                this.$store.dispatch("logOut").then(() => {
                                    this.$router.push("/login");
                                });
                                return;
                            }
                            return this.$swal.fire("Request ", error.response.data.message, "error");
                        }
                    }

                    this.$sentry.captureException(error);
                    this.$swal.fire("Error", error.message, "error");
                } finally {
                    await this.$store.dispatch("setLoading", false);
                }
            });
        },
        clearForm() {
            var self = this; //you need this because *this* will refer to Object.keys below`
            //Iterate through each object field, key is name of the object field`
            Object.keys(this.formInput).forEach(function (key) {
                self.formInput[key] = '';
            });
        }
    }
}
</script>

<style scoped>
input,
textarea {
    border-width: initial !important;
    border: 1px solid rgba(60, 60, 60, .26) !important;
}

div[class*="v-select vs--single vs--searchable"]>>>.vs__dropdown-toggle {
    height: 56px !important;
    border-radius: 0.6rem !important;
}
</style>
